import React, { Component } from 'react';
import { Card } from 'react-bootstrap';

import RenderItemStatus from './RenderItemStatus';

class AutofacturacionTicketGeneralInfo extends Component {
  render() {
    const { data = {} } = this.props;

    return (
      <Card>
        <Card.Body>
          <strong className="text-info card-label-info">Status: </strong>
          {<RenderItemStatus item={data} />}
          <br />
          <strong className="text-info card-label-info">Mensaje: </strong>
          {data.razon_status}
          <br />
          <strong className="text-info card-label-info">Código: </strong>
          {data.codigo}
          <br />
          <strong className="text-info card-label-info">Sucursal: </strong>
          {data.sucursal}
          <br />
          <strong className="text-info card-label-info">Folio Fiscal: </strong>
          {data.cfdi_uuid}
          <br />
          <strong className="text-info card-label-info">Emisor: </strong>
          {data.emisor_rfc}
          <br />
          <strong className="text-info card-label-info">Receptor: </strong>
          {data.receptor_rfc} {data.receptor_razon_social || ''}
          <br />
          <strong className="text-info card-label-info">Total: </strong>
          {data.total}
          <br />
          {data.errors && data.errors.length > 0 && (
            <>
              <strong className="text-info card-label-info">Errores: </strong>
              <ul>
                {data.errors.map((error, index) => (
                  <li key={index}>{error.message}</li>
                ))}
              </ul>
            </>
          )}
          <br />
          {[1, 'success'].indexOf(data.fpg_status) > -1 && [1, 'success'].indexOf(data.status) === -1 && (
            <>
              <br />
              <br />
              <strong>Ticket facturado en FPG</strong>
            </>
          )}
        </Card.Body>
      </Card>
    );
  }
}

export default AutofacturacionTicketGeneralInfo;
